import 'moment/locale/ko'
import momentTimezone from "moment-timezone"

export default {
    methods: {

        returnDateFormat(date, format='YYYY-MM-DD') {
            this.$moment.locale('ko')
            return this.$moment(date).format(format);
        },
        returnDateUnix(date, format='YYYY-MM-DD HH:mm') {
            if(!date) {
                return '';
            }
            return momentTimezone.unix(date).tz('Asia/Seoul').locale('ko').format(format)
        },
        returnMinuteToHourFormat(date) {
            let time = parseInt(date / 60);
            let min = date % 60;
            if (time < 10 && min < 10) {
                return `0${time}:0${min}`
            } else if (time < 10) {
                return `0${time}:${min}`
            } else if (min < 10) {
                return `${time}:0${min}`
            } else {
                return `${time}:${min}`
            }
        },
    },
}
